import React, { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';
import styles from "./Weather.module.scss";

function Weather() {
  const [query, setQuery] = useState("Bishkek");
  const [weather, setWeather] = useState({
    loading: false,
    data: {},
    error: false,
  });

  const toDate = () => {
    const months = [
        'Январь', 'Февраль', 'Март', 'Апрель', 
        'Май', 'Июнь', 'Июль', 'Август', 
        'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
    ];

    const currentDate = new Date();
    const day = currentDate.getDate(); // Получаем число месяца
    const month = currentDate.getMonth(); // Получаем номер месяца (0-11)
 // Получаем год

    // Форматируем дату
    const formattedDate = `${day}, ${months[month]}`;
    return formattedDate;
};

// Пример использования


  const toDate1 = () => {

    const days = [
      'Воскресенье',
      'Понедельник',
      'Вторник',
      'Среда',
      'Четверг',
      'Пятница',
      'Суббота',
    ];
    const currentDate = new Date();
    const date = `${days[currentDate.getDay()]}`;
    return date;
  };
  const search = async (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      setQuery('');

      setWeather({ ...weather, loading: true });
      const url = 'https://api.openweathermap.org/data/2.5/weather';
      const appid = 'f00c38e0279b7bc85480c3fe775d518c';
      //console.log('Enter');

      await axios
        .get(url, {
          params: {
            q: query,
            units: 'metric',
            appid: appid,
          },
        })
        .then((res) => {

          setWeather({ data: res.data, loading: false, error: false });
        })
        .catch((error) => {
          setWeather({ ...weather, data: {}, error: true });
          setQuery('');

        });
    }

  };
  const infoweather = async (queryinfo) => {

    setWeather({ ...weather, loading: true });
    const url = 'https://api.openweathermap.org/data/2.5/weather';
    const appid = 'f00c38e0279b7bc85480c3fe775d518c';
    //console.log('Enter');

    await axios
      .get(url, {
        params: {
          q: queryinfo,
          units: 'metric',
          appid: appid,
        },
      })
      .then((res) => {

        setWeather({ data: res.data, loading: false, error: false });
      })
      .catch((error) => {
        setWeather({ ...weather, data: {}, error: true });
        setQuery('');

      });


  };

  useEffect(() => {
  



    const getLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      } else {
        console.log("CHU");
      }
    }


    const showPosition = (position) => {
      const { latitude, longitude } = position.coords;
      reverseGeocode(latitude, longitude);

    }


    const reverseGeocode = async (latitude, longitude) => {
      try {
        // Запрос к сервису геокодирования OpenStreetMap
        const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`);
        const data = await response.json();
        const fullCityName = data.address.city || data.address.town || data.address.village || data.address.county || data.address.state || 'Unknown';
        // Получение города из результата геокодирования
        const cityNameArray = fullCityName.split(' ');

        // Выбираем последнее слово
        const lastWord = cityNameArray.pop();

        // Оставляем только последнее слово города
        const cityName = lastWord || 'Unknown';
        setQuery(cityName)
        infoweather(cityName)
      } catch (error) {
        console.error('CHU');
      }
    }

    getLocation();
    
  }, []);


  return (
    <div>


      {weather.loading && (
        <>
          {/* <br />
          <br /> */}
          {/* <Oval color="black" height={50} width={50} /> */}
        </>
      )}
      {weather.error && (
        <>
          <br />

          <span className={styles.error_message}>
            {/* <FontAwesomeIcon icon={faFrown} /> */}
            <span style={{ 'font-size': '20px' }}>Извините, город не найден </span>
          </span>
          <br />
        </>
      )}

      {weather && weather.data && weather.data.main && (
        <div className={styles.city_div}>
          <div>
            <div className={styles.city_name}>
              <h2>
                {weather.data.name}, <span>{toDate()}</span>
              </h2>
              <h2>
                <span>{toDate1()}</span>
              </h2>
            </div>



            <div className={styles.des_wind}>
              <p>{weather.data.weather[0].description.toUpperCase()}</p>
              <p>Скорость ветра: {weather.data.wind.speed}m/s</p>
            </div>
          </div>
          <div className={styles.icon_temp}>
            <img
              className=""
              src={`https://openweathermap.org/img/wn/${weather.data.weather[0].icon}@2x.png`}
              alt={weather.data.weather[0].description}
            />
            {Math.round(weather.data.main.temp)}
            <sup className={styles.deg}>&deg;C</sup>
          </div>
        </div>
      )}
      <div className={styles.search_bar}>
        <input
          type="text"
          className={styles.city_search}
          placeholder="Найти город.."
          name="query"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onKeyPress={search}
        />
      </div>

    </div>

  );

}

export default Weather;
